import { useLayoutContext } from '../../../Context/Layout.context';
import { updateMovie } from '../../../services/supportMovie/supportMovie.service';
import { IMovieListItem } from '../../../services/supportMovie/supportMovie.types';
import { MovieEditor } from '../MovieEditor/MovieEditor.component';

interface EditMovieProps {
  onClose: () => void;
  onChange: () => void;
  movieProp: IMovieListItem;
}

export const EditMovie: React.FC<EditMovieProps> = ({ onClose, onChange, movieProp: movieProp }) => {
  const handleClose = () => {
    onClose();
  };

  const { openAlert } = useLayoutContext();

  const handleEditMovie = (newTitle: string, newDescription: string, newUrl: string, id: string) => {
    updateMovie(newTitle, newDescription, newUrl, id).then(
      () => {
        openAlert('success');
        onChange();
        onClose();
      },
      () => {
        openAlert('save_error');
      },
    );
  };

  return (
    <MovieEditor
      title="Edytuj film"
      onCancel={handleClose}
      onSave={handleEditMovie}
      onChange={onChange}
      movieTitle={movieProp.title}
      movieDescription={movieProp.description}
      movieUrl={movieProp.url}
      movieId={movieProp.id}
    />
  );
};
